import React from 'react';

const AuthFormLayout: React.FC<{
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
}> = ({ title, children, footer, onSubmit }) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <h1 className="mb-6 text-center text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
    {children}
    {footer}
  </form>
);

export default AuthFormLayout;
